export * from './tab-group.component';
export * from './tab-group.module';
export * from './tab/tab.component';
